// @flow
import React, { Component, Fragment } from 'react';
import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import { FormattedMessage, intlShape } from 'react-intl';
import Modal from '../../../../../../elements/Modal/Modal';
import { FormValidator } from '../../../../../../utils/form';
import { Link } from 'react-router-dom';

import style from './VolumetricOptions.scss';
import baggageHuman from '../../../../../../assets/img/new-order/product-step/volumetric-options/modal_maleta.png';
import baggageHumanMobile
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/modal_maleta_mobile.png';
// import shoes from '../../../../../../assets/img/new-order/product-step/volumetric-options/shoes.svg';
import ShoesS from '../../../../../../assets/img/new-order/product-step/volumetric-options/shoes/shoes-S.inline.svg';
import ShoesM from '../../../../../../assets/img/new-order/product-step/volumetric-options/shoes/shoes-M.inline.svg';
import ShoesL from '../../../../../../assets/img/new-order/product-step/volumetric-options/shoes/shoes-L.inline.svg';
import ShoesXL from '../../../../../../assets/img/new-order/product-step/volumetric-options/shoes/shoes-XL.inline.svg';

import CpuS from '../../../../../../assets/img/new-order/product-step/volumetric-options/computer-parts/cpu-S.inline.svg';
import GraphicCardM from '../../../../../../assets/img/new-order/product-step/volumetric-options/computer-parts/graphiccard-M.inline.svg';
import MotherboardL from '../../../../../../assets/img/new-order/product-step/volumetric-options/computer-parts/motherboard-L.inline.svg';
import KeyboardXL from '../../../../../../assets/img/new-order/product-step/volumetric-options/computer-parts/keyboard-XL.inline.svg';

import EarphonesXS from '../../../../../../assets/img/new-order/product-step/volumetric-options/headphones/earphones-XS.inline.svg';
import HeadphonesS from '../../../../../../assets/img/new-order/product-step/volumetric-options/headphones/headphones-S.inline.svg';

import VitaminsS
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/vitamins/vitamins-S.inline.svg';
import VitaminsM
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/vitamins/vitamins-M.inline.svg';
import VitaminsL
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/vitamins/vitamins-L.inline.svg';

import CameraS from '../../../../../../assets/img/new-order/product-step/volumetric-options/camera/camera-S.inline.svg';
import CameraM from '../../../../../../assets/img/new-order/product-step/volumetric-options/camera/camera-M.inline.svg';
import CameraL from '../../../../../../assets/img/new-order/product-step/volumetric-options/camera/camera-L.inline.svg';
import CameraXL
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/camera/camera-XL.inline.svg';

import MakeupS from '../../../../../../assets/img/new-order/product-step/volumetric-options/makeup/makeup-S.inline.svg';
import MakeupM from '../../../../../../assets/img/new-order/product-step/volumetric-options/makeup/makeup-M.inline.svg';
import MakeupL from '../../../../../../assets/img/new-order/product-step/volumetric-options/makeup/makeup-L.inline.svg';
import MakeupXL
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/makeup/makeup-XL.inline.svg';

import clothXS from '../../../../../../assets/img/new-order/product-step/volumetric-options/cloth/cloth-xs.inline.svg';
import clothS from '../../../../../../assets/img/new-order/product-step/volumetric-options/cloth/cloth-s.inline.svg';
import clothM from '../../../../../../assets/img/new-order/product-step/volumetric-options/cloth/cloth-m.inline.svg';

import OtherS from '../../../../../../assets/img/new-order/product-step/volumetric-options/other/other-S.inline.svg';
import OtherM from '../../../../../../assets/img/new-order/product-step/volumetric-options/other/other-M.inline.svg';
import OtherL from '../../../../../../assets/img/new-order/product-step/volumetric-options/other/other-L.inline.svg';
import OtherXL
  from '../../../../../../assets/img/new-order/product-step/volumetric-options/other/other-XL.inline.svg';

import ConsoleS from '../../../../../../assets/img/new-order/product-step/volumetric-options/consoles/console-S.inline.svg';
import ConsoleM from '../../../../../../assets/img/new-order/product-step/volumetric-options/consoles/console-M.inline.svg';
import ConsoleL from '../../../../../../assets/img/new-order/product-step/volumetric-options/consoles/console-L.inline.svg';

import TabletM from '../../../../../../assets/img/new-order/product-step/volumetric-options/tablets/tablets-M.inline.svg';
import TabletL from '../../../../../../assets/img/new-order/product-step/volumetric-options/tablets/tablets-L.inline.svg';

import type { Category } from '../../../../../../entities';
import type { LocaleState } from '../../../../../locale/duck';

type Props = {
  +value: ?number;
  +category: Category;
  +onChange: (value: number) => void;
  +localeState: LocaleState;
  +errors?: string[];
};

type State = {
  openModal: boolean;
  openOptions: boolean;
};

const images = {
  '2': [CpuS, GraphicCardM, MotherboardL, KeyboardXL],
  '4': [CameraS, CameraM, CameraL, CameraXL],
  // '6': [VitaminsS, VitaminsM, VitaminsL],
  // '8': [clothXS, clothS, clothM],
  '11': [TabletM, TabletL],
  '12': [ShoesS, ShoesM, ShoesL, ShoesXL],
  // '13': [MakeupS, MakeupM, MakeupL, MakeupXL],
  // '9': [OtherS, OtherM, OtherL, OtherXL],
  '16': [ConsoleS, ConsoleM, ConsoleL],
  '22': [EarphonesXS, HeadphonesS],
};

export default class VolumetricOptions extends Component<Props, State> {
  state = {
    openModal: false,
    openOptions: true,
  };
  
  constructor(props: Props) {
    super(props);
    this.state = {
      openModal: false,
      openOptions: !props.value,
    };
  }

  handleOpenModal = () => {
    this.setState({ openModal: true });
  };

  handleCloseModal = () => {
    this.setState({ openModal: false });
  };
  
  handleChangeTier = (index: number) => {
    const { onChange } = this.props;
    this.setState({ openOptions: false });
    onChange(index);
  };
  
  handleToggleOpenOptions = () => {
    const { value } = this.props;
    this.setState((s: State) => {
      if (s.openOptions && typeof value === 'undefined') {
        return ({ openOptions: s.openOptions });
      }
      
      return ({
        openOptions: !s.openOptions,
      });
    });
  };

  getVolumetricImage = (categoryId: number, index: number) => {
    if (images[`${categoryId}`]) return images[categoryId][index];
    return [OtherS, OtherM, OtherL, OtherXL][index];
  };

  buildOptions = () => {
    const { localeState, category, onChange, value, errors } = this.props;
    const { openOptions } = this.state;
    return category.volumeTiers
      .filter((tier: { [key: string]: any }) => tier.enabled)
      .map((tier: { [key: string]: any }, index: number) => {
        const SVG = this.getVolumetricImage(category.id, index);
        return (
          <div key={index}
               className={classNames(style.volumetricOption,
                 { [style.error]: !!errors && errors.length },
                 { [style.active]: value === index })}
               onClick={() => this.handleChangeTier(index)}>
            <div className={style.volumetricOptionContent}>
              <div className={style.svgWrapper}>
                {SVG && <SVG/>}
              </div>
              <section className={style.translationsWrap}>
                <p className={style.label}>
                  {tier.translations[localeState ? localeState.locale.toUpperCase() : 'ES'].label}</p>
                <p className={style.description}>
                  {tier.translations[localeState ? localeState.locale.toUpperCase() : 'ES'].description}</p>
              </section>
            </div>
          </div>
        );
      })
      .filter((tier: { [key: string]: any }, index: number) => {
        if (openOptions) return true;
        return typeof value === 'number' ? value === index : true;
      });
  };

  render() {
    const { openModal, openOptions } = this.state;
    const { errors } = this.props;

    const volumetricError = !!errors && FormValidator.buildErrorLabel(errors, {
      required: 'newOrder.product.form.volumetric.required',
    });

    const optionsWrap =
      <section className={style.volumetricOptionsWrap}>
        <FormattedMessage id="newOrder.product.form.volumetric.title">{
          txt => <h3 className={style.title}>
            {txt}
            <FormattedMessage id={
              openOptions ? 
                'newOrder.product.form.volumetric.close' : 
                'newOrder.product.form.volumetric.change'
            }>{
              txt => <button onClick={this.handleToggleOpenOptions}>{txt}</button>
            }</FormattedMessage>
          </h3>
        }</FormattedMessage>
        {this.buildOptions()}
        {volumetricError}
      </section>;

    return (
      <Fragment>
        {optionsWrap}
        <Modal open={openModal}
               width={465}
               height={472}
               handleClose={this.handleCloseModal}>
          <section className={style.modalWrap}>
            <FormattedMessage id="newOrder.product.form.volumetric.modal.title">{
              text => <h2>{text}</h2>
            }</FormattedMessage>
            <img className={style.desktop} src={baggageHuman} alt="qempo"/>
            <img className={style.mobile} src={baggageHumanMobile} alt="qempo"/>
          </section>
        </Modal>
      </Fragment>
    );
  }
}

VolumetricOptions.propTypes = {
  value: PropTypes.number,
  category: PropTypes.object,
  onChange: PropTypes.func.isRequired,
  localeState: PropTypes.object,
  errors: PropTypes.array,
};

VolumetricOptions.contextTypes = {
  intl: intlShape,
};



// WEBPACK FOOTER //
// ./src/modules/new-order/ProductStep/components/ProductForm/VolumetricOptions/VolumetricOptions.jsx